import { initializeApp, getApps } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import cookie from '../utils/cookie';
import { getAuth } from 'firebase/auth';
import { isEmailNotVerified, signOutAdmin, verifiedAdminToken } from './admin_session';
import { getAppCheckV3Key } from '../utils/base_url';

export const firebaseAuthApp = () => {
  const existing = getApps().find(app => app.name === 'auth');
  if (existing) return existing;
  const app = initializeApp(authConfig(), 'auth');
  if (process.env.REACT_APP_MODE === 'test' || process.env.REACT_APP_MODE === 'prod') {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(getAppCheckV3Key()),
      isTokenAutoRefreshEnabled: true,
    })
  }
  return app;
}

export const authConfig = () => {
  let firebaseAuthConfig = {
    apiKey: "AIzaSyCLH6AYhX32QO_mO8TXQ5tsrIOWq1fYUuM",
    authDomain: "go-wallet-dev-396512.firebaseapp.com",
    projectId: "go-wallet-dev-396512",
    storageBucket: "go-wallet-dev-396512.appspot.com",
    messagingSenderId: "254703063534",
    appId: "1:254703063534:web:38fa458945dfa6aaba3eff",
    measurementId: "G-02CF9GXMBL"
  };

  if (process.env.REACT_APP_MODE === 'test') {
    firebaseAuthConfig = {
      apiKey: "AIzaSyAP4Mq1UVjp7UJQU9s8fFBouOz1ZWlTaAM",
      authDomain: "go-wallet-test-396515.firebaseapp.com",
      projectId: "go-wallet-test-396515",
      storageBucket: "go-wallet-test-396515.appspot.com",
      messagingSenderId: "979486348420",
      appId: "1:979486348420:web:a6a56816ca2565d8ba1ed1",
      measurementId: "G-V52SM5381W"
    };
  } else if (process.env.REACT_APP_MODE === 'prod') {
    firebaseAuthConfig = {
      apiKey: "AIzaSyBtURlA2pCuMoi-fHsaGPBjHUhXLAo3nxM",
      authDomain: "go-wallet-production-396515.firebaseapp.com",
      projectId: "go-wallet-production-396515",
      storageBucket: "go-wallet-production-396515.appspot.com",
      messagingSenderId: "562260331334",
      appId: "1:562260331334:web:d179a0dd85b5bcba3c7347",
      measurementId: "G-EGJCV4TJL5"
    };
  }
  return firebaseAuthConfig;
}

export const refreshJWTToken = async (onSuccess, onFail) => {
  try {
    const auth = getAuth(firebaseAuthApp());
    await auth.authStateReady();
    const user = auth.currentUser;
    if (!user) throw new Error('No authentication session');
    const token = await verifiedAdminToken(user);
    if (auth.currentUser !== user) throw new Error('Authentication session changed');
    cookie.setCookie('user-token', token);
    onSuccess();
  } catch (error) {
    if (isEmailNotVerified(error)) await signOutAdmin(getAuth(firebaseAuthApp())).catch(() => {});
    onFail(error);
  }
};
